// @flow strict
import React from 'react'

import Button from '../../atoms/Button'
import styles from './NotFoundSection.module.scss'
import SadHotChip from '../../static/illustrations/sad-hot-chip.svg'

const NotFoundSection = () => (
  <div className={styles.main}>
    <section className={styles.container}>
      <div>
        <h1 className={styles.title}>404</h1>
        <p className={styles.subtitle}>
          Sorry we can't find the page you're looking for.
        </p>
        <Button href="https://monzo.com">Visit the home page</Button>
      </div>
      <div>
        <img
          className={styles.image}
          src={SadHotChip}
          alt="hot chip looking sad because he is lost"
        />
      </div>
    </section>
  </div>
)

export default NotFoundSection
